import './salesforceQuickstartPackages.scss';
import Header from '../../src-utilities/header';
import '../../src-utilities/multipleBadges';
import './../../src-utilities/footer';
import Swiper from './../../../node_modules/swiper';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';
import './../../src-utilities/getInTouch';
import initPorfolio from './../../src-utilities/portfolio';
import './../../src-utilities/industries';
import AOS from 'aos';
import testimonial from '../../src-utilities/testimonial';
new Header();

AOS.init({
	initClassName: 'animation-init',
	animatedClassName: 'animation',
	once: true,
	easing: 'ease-in-quart',
});

gsap.registerPlugin(ScrollTrigger);

// Hero Section Animation
gsap.matchMedia().add('(min-width:1050px)', () => {
	gsap.timeline({
		onStart: () => {
			document.querySelector(
				'.hero-section .consultation_button',
			).style.background = 'var(--hero-btn-background)';
			document.querySelector(
				'.hero-section .consultation_button',
			).style.color = 'var(--btn-text)';
		},
		onReverseComplete: () => {
			document.querySelector(
				'.hero-section .consultation_button',
			).style.background = 'transparent';
			document.querySelector(
				'.hero-section .consultation_button',
			).style.color = 'var(--heading-color)';
		},

		scrollTrigger: {
			trigger: '.hero-section',
			scrub: true,
			pinSpacing: false,
			start: '20% 20%',
			end: () => document.querySelector('.hero-image').clientHeight,
		},
	})
		.to('.hero-section .container', {
			yPercent: 100,
		})
		.to(
			'.hero-section .hero-image',
			{
				opacity: 0.2,
			},
			0,
		);
});

//faq section js code
const BindEvent = () => {
	let faq_question = document.getElementsByClassName('faq-question');
	let hiddenFaqs = document.querySelectorAll('.hidden-faq');
	let viewAllFaqBtn = document.querySelector('.faq-view-btn');

	for (let i = 0; i < faq_question.length; i++) {
		const question = faq_question[i];
		question.addEventListener('click', function (e) {
			let all_faq = document.getElementsByClassName('faq');
			let isopen =
				e.currentTarget.parentNode.classList.contains('active');
			for (let index = 0; index < all_faq.length; index++) {
				all_faq[index].classList.remove('active');
			}
			if (isopen == false) {
				e.currentTarget.parentNode.classList.add('active');
			}
		});
	}

	viewAllFaqBtn.addEventListener('click', () => {
		if (!viewAllFaqBtn.classList.contains('active')) {
			viewAllFaqBtn.textContent = 'View Less';
			viewAllFaqBtn.classList.add('active');
			hiddenFaqs.forEach((hiddenFaq) => {
				hiddenFaq.style.display = 'flex';
			});
		} else {
			viewAllFaqBtn.textContent = 'View All';
			viewAllFaqBtn.classList.remove('active');
			hiddenFaqs.forEach((hiddenFaq) => {
				hiddenFaq.style.display = 'none';
			});
		}
	});
};
BindEvent();

// right choice section
rightChoice();

// portfoliio
initPorfolio();

// Testimonial
testimonial();

// our customer
new Swiper('.customers-logo', {
	modules: [Autoplay],
	slidesPerView: 6,
	loop: true,
	autoplay: {
		delay: 10,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 2000,
	breakpoints: {
		0: {
			spaceBetween: 15,
			slidesPerView: 3,
		},
		600: {
			slidesPerView: 5,
			spaceBetween: 30,
		},
	},
});

window.addEventListener('resize', function () {
	ScrollTrigger.refresh();
});

new Swiper('.deep-dive-section-slider', {
	modules: [Autoplay, Navigation],
	loop: true,
	autoplay: {
		delay: 2000,
	},
	slidesPerView: 3,
	spaceBetween: 100,
	autoplay: false,
	navigation: {
		nextEl: '.deep-dive-section .swiper-button-next',
		prevEl: '.deep-dive-section .swiper-button-prev',
	},
	breakpoints: {
		320: {
			slidesPerView: 1,
			spaceBetween: 100,
		},
		600: {
			slidesPerView: 2,
			spaceBetween: 40,
		},
		1000: {
			slidesPerView: 3,
			spaceBetween: 60,
		},
		1200: {
			slidesPerView: 3,
			spaceBetween: 100,
		},
	},
});

//#region Choice Section
function rightChoice() {
	let isStatsVisilble = false;
	const target = document.querySelector('.cyntexa-right-choice');
	function handleIntersection(entries) {
		entries.map((entry) => {
			if (entry.isIntersecting) {
				if (!isStatsVisilble) {
					isStatsVisilble = true;
					document
						.querySelectorAll('.stats')
						.forEach(function (element) {
							var countTo = parseInt(
								element.getAttribute('data-stats'),
							);
							var countNum = parseInt(element.textContent);

							var duration = 3000;
							var startTime = null;

							function animate(timestamp) {
								if (!startTime) startTime = timestamp;
								var progress = timestamp - startTime;
								var increment = (countTo / duration) * progress;

								if (progress < duration) {
									element.textContent = Math.floor(
										countNum + increment,
									);
									requestAnimationFrame(animate);
								} else {
									element.textContent = countTo;
								}
							}

							requestAnimationFrame(animate);
						});
				}
			}
		});
	}
	const observer = new IntersectionObserver(handleIntersection);

	observer.observe(target);

	let sections = gsap.utils.toArray('.cyntexa-right-choice .box');
	let boxes = document.querySelector('.cyntexa-right-choice .boxes');
	let picture = document.querySelector('.cyntexa-right-choice .picture');

	gsap.matchMedia().add('(min-width: 65.625em)', () => {
		let rightChoice = gsap.timeline({
			scrollTrigger: {
				trigger: '.cyntexa-right-choice',
				start: 'center center',
				end: () => boxes.offsetWidth + 'bottom',
				scrub: true,
				pin: '.cyntexa-right-choice',
				pinSpacing: true,
				pinType: 'fixed',
			},
		});

		rightChoice
			.fromTo(
				'.cyntexa-right-choice .picture',
				{
					width: '100%',
				},
				{
					width: '600px',
					height: '300px',
					duration: 1,
					scrollTrigger: {
						end: () => '+=' + picture.clientHeight,
					},
					onComplete: function () {
						let video = document.querySelector(
							'.cyntexa-right-choice video',
						);
						video.play();
						video.style.opacity = 1;
					},
				},
			)
			.to(
				sections,
				{
					duration: 3,
					xPercent: -100 * sections.length,
					onReverseComplete: function () {
						let video = document.querySelector(
							'.cyntexa-right-choice video',
						);
						video.pause();
						video.style.opacity = 0;
					},
				},
				'>',
			);
	});

	gsap.matchMedia().add('(max-width: 65.625em)', () => {
		let container = document.querySelector(
			'.cyntexa-right-choice .container',
		);
		let rightChoice = gsap.timeline({
			scrollTrigger: {
				trigger: '.cyntexa-right-choice',
				start: 'center-=30px center',
				end: () => boxes.offsetWidth + 'bottom',
				scrub: true,
				pin: '.cyntexa-right-choice',
				pinSpacing: true,
				pinType: 'fixed',
				onLeaveBack: function () {
					let video = document.querySelector(
						'.cyntexa-right-choice video',
					);
					video.pause();
					video.style.opacity = 0;
				},
			},
		});

		rightChoice.to(
			sections,
			{
				onStart: function () {
					let video = document.querySelector(
						'.cyntexa-right-choice video',
					);
					video.play();
					video.style.opacity = 1;
				},
				duration: 3,
				xPercent: -100 * (sections.length - 1),
			},
			'>',
		);
	});
}
